export const OPT_OUT_BUTTON_OPTIONS: Record<string, string[]> = {
    "en-US": [
        "Disable Reminder",
        "Turn Off",
        "Stop Alert",
        "No Reminder",
        "Opt Out",
        "End Reminder",
        "Silence Alert",
        "Cancel Notice",
        "Do Not Notify",
        "Dismiss Reminder",
    ],
    "en-GB": [
        "Turn Off",
        "Disable Reminder",
        "Stop Alerts",
        "No Reminders",
        "Opt Out",
        "Dismiss Reminder",
    ],
    "es-ES": [
        "Desactivar recordatorio",
        "Cancelar aviso",
        "No recordar",
        "Detener alertas",
        "Darse de baja",
        "Silenciar aviso",
    ],
    "es-MX": [
        "Desactivar recordatorio",
        "Cancelar aviso",
        "No enviar recordatorios",
        "Detener alertas",
        "Darse de baja",
        "Silenciar aviso",
    ],
    "fr-FR": [
        "Désactiver le rappel",
        "Arrêter les alertes",
        "Ne plus me rappeler",
        "Se désabonner",
        "Annuler l’avis",
        "Mettre en sourdine",
    ],
    "fr-CA": [
        "Désactiver le rappel",
        "Arrêter les alertes",
        "Ne plus me rappeler",
        "Se désabonner",
        "Annuler l’avis",
        "Mettre en sourdine",
    ],
    "de-DE": [
        "Erinnerung deaktivieren",
        "Benachrichtigungen stoppen",
        "Nicht mehr erinnern",
        "Abmelden",
        "Alarm stummschalten",
        "Hinweis beenden",
    ],
    "it-IT": [
        "Disattiva promemoria",
        "Interrompi avvisi",
        "Non ricordarmelo",
        "Annulla avviso",
        "Annulla iscrizione",
        "Silenzia avviso",
    ],
    "pt-PT": [
        "Desativar lembrete",
        "Parar alertas",
        "Não lembrar",
        "Anular aviso",
        "Cancelar subscrição",
        "Silenciar aviso",
    ],
    "pt-BR": [
        "Desativar lembrete",
        "Parar alertas",
        "Não lembrar",
        "Cancelar aviso",
        "Cancelar inscrição",
        "Silenciar aviso",
    ],
    "nl-NL": [
        "Herinnering uitschakelen",
        "Meldingen stoppen",
        "Niet meer herinneren",
        "Afmelden",
        "Melding dempen",
        "Melding annuleren",
    ],
    "da-DK": [
        "Slå påmindelse fra",
        "Stop advarsler",
        "Ingen påmindelser",
        "Afmeld",
        "Dæmp advarsel",
        "Annullér påmindelse",
    ],
    "sv-SE": [
        "Inaktivera påminnelse",
        "Stoppa aviseringar",
        "Inga fler påminnelser",
        "Avsluta",
        "Tysta avisering",
        "Avbryt påminnelse",
    ],
    "no-NO": [
        "Slå av påminnelse",
        "Stopp varsler",
        "Ingen flere påminnelser",
        "Meld meg av",
        "Demp varsel",
        "Avbryt påminnelse",
    ],
    "fi-FI": [
        "Poista muistutus käytöstä",
        "Lopeta ilmoitukset",
        "Älä muistuta",
        "Peruuta ilmoitus",
        "Lopeta tilaus",
        "Mykistä ilmoitus",
    ],
    "pl-PL": [
        "Wyłącz przypomnienie",
        "Zatrzymaj alerty",
        "Nie przypominaj",
        "Wypisz mnie",
        "Wycisz alert",
        "Anuluj powiadomienie",
    ],
    "tr-TR": [
        "Hatırlatmayı kapat",
        "Uyarıları durdur",
        "Beni hatırlatma",
        "Abonelikten çık",
        "Uyarıyı sustur",
        "Bildirimi iptal et",
    ],
    "ru-RU": [
        "Отключить напоминание",
        "Остановить уведомления",
        "Больше не напоминать",
        "Отписаться",
        "Отключить звук уведомления",
        "Отменить уведомление",
    ],
    "ar-SA": [
        "إيقاف التذكير",
        "إيقاف التنبيهات",
        "عدم التذكير",
        "إلغاء الاشتراك",
        "كتم التنبيه",
        "إلغاء الإشعار",
    ],
    "he-IL": [
        "להסרה לחצו כאן",
        "כיבוי עדכונים בנושא",
        "הפסקת תזכורות",
        "בלי תזכורות, תודה",
        "כיבוי תזכורות",
        "הסר אותי מרשימה",
    ],
    "zh-CN": [
        "关闭提醒",
        "停止提醒",
        "不再提醒",
        "退订",
        "静音通知",
        "取消通知",
    ],
    "zh-TW": [
        "關閉提醒",
        "停止提醒",
        "不再提醒",
        "退訂",
        "靜音通知",
        "取消通知",
    ],
    "ja-JP": [
        "リマインドをオフにする",
        "通知を停止",
        "今後は通知しない",
        "配信停止",
        "通知をミュート",
        "通知を取り消す",
    ],
    "ko-KR": [
        "알림 끄기",
        "알림 중지",
        "다시 알리지 않기",
        "수신 거부",
        "알림 음소거",
        "알림 취소",
    ],
    "hi-IN": [
        "रिमाइंडर बंद करें",
        "अलर्ट रोकें",
        "दोबारा न याद दिलाएँ",
        "अनसब्सक्राइब करें",
        "अलर्ट म्यूट करें",
        "सूचना रद्द करें",
    ],
    "th-TH": [
        "ปิดการเตือน",
        "หยุดการแจ้งเตือน",
        "ไม่ต้องเตือนอีก",
        "ยกเลิกการรับ",
        "ปิดเสียงการแจ้งเตือน",
        "ยกเลิกการแจ้ง",
    ],
    "vi-VN": [
        "Tắt nhắc nhở",
        "Dừng thông báo",
        "Không nhắc nữa",
        "Hủy đăng ký",
        "Tắt tiếng thông báo",
        "Hủy thông báo",
    ],
    "id-ID": [
        "Matikan pengingat",
        "Hentikan notifikasi",
        "Jangan ingatkan lagi",
        "Berhenti berlangganan",
        "Bisukan notifikasi",
        "Batalkan notifikasi",
    ],
    "ms-MY": [
        "Matikan peringatan",
        "Hentikan notifikasi",
        "Jangan ingatkan lagi",
        "Nyahlanggan",
        "Bisukan notifikasi",
        "Batalkan notifikasi",
    ],
    "el-GR": [
        "Απενεργοποίηση υπενθύμισης",
        "Διακοπή ειδοποιήσεων",
        "Να μην με ξαναθυμίσει",
        "Κατάργηση εγγραφής",
        "Σίγαση ειδοποίησης",
        "Ακύρωση ειδοποίησης",
    ],
    "cs-CZ": [
        "Vypnout připomínku",
        "Zastavit upozornění",
        "Už nepřipomínat",
        "Odhlásit se",
        "Ztišit upozornění",
        "Zrušit oznámení",
    ],
    "hu-HU": [
        "Emlékeztető kikapcsolása",
        "Értesítések leállítása",
        "Ne emlékeztessen",
        "Leiratkozás",
        "Értesítés némítása",
        "Értesítés törlése",
    ],
    "ro-RO": [
        "Dezactivează reminderul",
        "Oprește alertele",
        "Nu mă mai anunța",
        "Dezabonare",
        "Dezactivează sunetul alertei",
        "Anulează notificarea",
    ],
    "sk-SK": [
        "Vypnúť pripomienku",
        "Zastaviť upozornenia",
        "Už nepripomínať",
        "Odhlásiť sa",
        "Stlmiť upozornenie",
        "Zrušiť oznámenie",
    ],
    "uk-UA": [
        "Вимкнути нагадування",
        "Зупинити сповіщення",
        "Більше не нагадувати",
        "Відписатися",
        "Вимкнути звук сповіщень",
        "Скасувати сповіщення",
    ],
    "bg-BG": [
        "Изключи напомнянето",
        "Спри известията",
        "Без повече напомняния",
        "Отписване",
        "Заглуши известието",
        "Отмени известието",
    ],
};
